import React from 'react';
import { Formik, Form as FormikForm } from 'formik';

const Form = FormikForm as unknown as React.ComponentType<
  React.PropsWithChildren<Record<string, unknown>>
>;

import { getTranslation } from 'helpers/getTranslation';

import { Drawer } from 'components/shared/Drawer';
import { Button } from 'components/shared/Button';
import { Loading } from 'components/shared/Loading';

import { FormikField } from 'components/FormikField';
import { SelectField } from 'components/FormikFields';

import { platformOptions } from './CreateCourse.config';

import { initialValues, validationSchema } from './CreateCourse.formConfig';

import styles from './CreateCourse.module.scss';

const CreateCourse = ({
  open,
  createLoading,
  schoolOptions,
  onClose,
  onCreateClick,
}: {
  open: any;
  createLoading: any;
  schoolOptions: any;
  onClose: any;
  onCreateClick: any;
}) => (
  <Drawer
    open={open}
    headerContent={getTranslation('courses_page.create_course.title')}
    onClose={onClose}
  >
    <Formik
      enableReinitialize
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={onCreateClick}
    >
      <Form className={styles.form}>
        <div className={styles.inner}>
          <FormikField
            name="platform"
            component={SelectField}
            componentProps={{ options: platformOptions }}
            controlProps={{
              required: true,
              label: getTranslation(
                'courses_page.create_course.platform_label',
              ),
            }}
          />
          <FormikField
            name="school"
            component={SelectField}
            componentProps={{
              options: schoolOptions,
            }}
            controlProps={{
              required: true,
              label: getTranslation('courses_page.create_course.school_label'),
            }}
          />
        </div>
        <div className={styles.actions}>
          <Button
            className={styles.action}
            size="md"
            variant="outlined"
            onClick={onClose}
          >
            {getTranslation('common.button.cancel')}
          </Button>
          <Button
            className={styles.action}
            startIcon={
              createLoading && <Loading color={'var(--color-white-primary)'} />
            }
            type="submit"
            size="md"
          >
            {getTranslation('common.button.create')}
          </Button>
        </div>
      </Form>
    </Formik>
  </Drawer>
);

export default React.memo(CreateCourse) as any;
